<template>
	<article class="faq-item" :class="[{'active': active === true}, mode == 'cd' && 'cd-faq-item']">
		<div class="faq-item-title" :class="[mode == 'cd' && 'cd-faq-item-title']" @click="active = !active"><span class="plus"></span><span class="faq-item-just-title">{{item.title}}</span></div>
		<div class="faq-item-desc" :class="[mode == 'cd' && 'cd-faq-item-desc']" v-if="item?.content" v-html="item.content" v-interpolation></div>
	</article>
</template>

<script setup>
	const props = defineProps(['item', 'mode']);
	const active = ref(0);
</script>

<style lang="less" scoped>
	.faq-item{
		padding: 0 0 2px 29px; overflow: hidden; margin-bottom: 15px;
		&.active .faq-item-desc{max-height: 2000px; color: var(--textColor); padding-top: 5px;}
		&.active .faq-item-title{
			color: var(--primaryColor);
			span{
				&:after{display: none;}
			}
		}
		@media (max-width: @t){margin-bottom: 14px;}
		@media (max-width: @m){
			margin-bottom: 10px; padding: 0 0 2px 23px;
			&.active{
				.faq-item-desc{padding-top: 3px;}
			}
		}
	}
	.faq-item-desc{
		max-height: 0; .transition(all); font-size: 20px; line-height: 28px; font-weight: 300;
		:deep(p){
			font-size: 20px; line-height: 30px; font-weight: 300px; padding-bottom: 8px;
			@media (max-width: @t){font-size: 18px; line-height: 25px;}
			@media (max-width: @m){font-size: 14px; line-height: 20px;}
		}
		@media (max-width: @t){font-size: 18px; line-height: 25px;}
		@media (max-width: @m){font-size: 14px; line-height: 20px;}
	}
	.faq-item-just-title{position: relative; font-weight: normal;}
	.faq-item-title{
		font-size: 24px; line-height: 32px; position: relative; cursor: pointer; color: var(--textColor); padding-bottom: 3px;
		.plus{position: absolute; width: 14px; height: 2px; background: var(--primaryColor); top: 14px; left: -29px; content: "";
			&:after{width: 14px; height: 2px; position: absolute; background: var(--primaryColor); content: ""; left: 0; transform: rotate(90deg); top: 0;}
		}
		@media(min-width: @h){
			&:hover{color: var(--primaryColor);}
		}
		@media (max-width: @t){
			font-size: 22px; line-height: 26px; padding-bottom: 3px;
			.plus{top: 11px;}
		}
		@media (max-width: @m){
			font-size: 18px; line-height: 23px; padding-bottom: 2px;
			.plus{
				top: 10px; width: 12px; height: 2px; left: -23px;
				&:after{width: 12px; height: 2px;}
			}
		}
	}

	.cd-faq-item{
		margin-bottom: 10px; padding: 0 0 2px 28px;
		@media (max-width: @t){margin-bottom: 10px;}
		@media (max-width: @m){margin-bottom: 9px; padding: 0 0 2px 22px;}
	}
	.cd-faq-item-title{
		font-size: 22px; line-height: 26px; font-weight: normal;
		@media (max-width: @t){font-size: 20px; line-height: 24px; padding-bottom: 3px;}
		@media (max-width: @m){font-size: 16px; line-height: 21px; padding-bottom: 2px;}
		.plus{
			width: 14px; height: 2px; top: 11px; left: -28px;
			@media (max-width: @t){top: 11px;}
			@media (max-width:@m){top: 9px; width: 12px; height: 2px; left: -22px;}
			&:after{
				width: 14px; height: 2px;
				@media (max-width: @m){width: 12px; height: 2px;}
			}
		}
	}
	.cd-faq-item-desc{
		font-size: 18px; line-height: 24px;
		@media (max-width: @t){font-size: 16px; line-height: 22px;}
		p{
			font-size: 18px; line-height: 24px;
			@media (max-width: @t){font-size: 16px; line-height: 22px;}
		}
		.cms-content{padding-right: 0;}
	}
</style>
